import React, { Component } from 'react';
import Header from '../../Common/HeaderMain/HeaderMain';
import Footer from '../../Common/FooterMain/FooterMain';
import Notice from '../../Experience/ExMain/NoticeGrid/NoticeGrid'

class RouterNotice extends Component {
    render() {
        return (
            <div>
                <Header/>
                <Notice/>
                <Footer/>
            </div>
        );
    }
}

export default RouterNotice;